export const environment = {
  production: false,
  apiUrl: 'https://api.dev.comunidades.lec.digital/api/v1'
};